'use strict'

import Vue from 'vue'

const state = {
  menuList: [],
  autoMenuList: [],
  navigation: {},
  middleMenuList: [],
  navigationMiddleList: [],
  navigationSmallList: [],
  rootMenuName: '',
  lowMenuName: '',
  changeActive: 0
}

const getters = {
  getMenuList (state) {
    return state.menuList
  },
  getAutoMenuList (state) {
    return state.autoMenuList
  },
  getNavigation (state) {
    return state.navigation
  },
  getMiddleMenuList (state) {
    return state.middleMenuList
  },
  getNavigationMiddleList (state) {
    return state.navigationMiddleList
  },
  getNavigationSmallList (state) {
    return state.navigationSmallList
  },
  getRootMenuName (state) {
    return state.rootMenuName
  },
  getLowMenuName (state) {
    return state.lowMenuName
  },
  getChangeActive (state) {
    return state.changeActive
  }
}

const mutations = {
  setMenuList (state, { menuList }) {
    state.menuList = menuList
  },
  setAutoMenuList (state, { autoMenuList }) {
    state.autoMenuList = autoMenuList
  },
  setNavigation (state, { navigation }) {
    state.navigation = navigation
  },
  setMiddleMenuList (state, { middleMenuList }) {
    state.middleMenuList = middleMenuList
  },
  setNavigationMiddleList (state, { navigationMiddleList }) {
    state.navigationMiddleList = navigationMiddleList
  },
  setNavigationSmallList (state, { navigationSmallList }) {
    state.navigationSmallList = navigationSmallList
  },
  setRootMenuName (state, { rootMenuName }) {
    state.rootMenuName = rootMenuName
  },
  setLowMenuName (state, { lowMenuName }) {
    state.lowMenuName = lowMenuName
  },
  setChangeActive (state, count) {
    state.changeActive = count
  }
}

const actions = {
  changeActive ({commit}, params) {
    commit('setChangeActive', params)
  },
  load ({ commit, state }) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .get('/api/appmgmt/menu/list')
        .then(response => {
          if (response.data.result) {
            commit('setMenuList', {
              menuList: response.data.result
            })
          }else{
            commit('setMenuList', {
              menuList: []
            })
          }
          resolve()
        })
        .catch(e => reject(e))
    })
  },
  autoMenu ({ commit, state }) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .get('/api/appmgmt/menu/list/autoMenu')
        .then(response => {
          if (response.data.result) {
            commit('setAutoMenuList', {
              autoMenuList: response.data.result
            })
          }
          resolve()
        })
        .catch(e => reject(e))
    })
  },
  navigation ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      if (params.path == '/home') {
        // 메뉴 숨김
        $('.side').addClass('active')
        $('.lnb_wrap .close').addClass('active')
        $('.lnb_wrap .lnb_menu').addClass('active')

        commit('setNavigation', {
          navigation: { urlPath: '/home', menuName: 'home' }
        })
        state.middleMenuList = []
        state.rootMenuName = ''
        state.lowMenuName = 'home'
        resolve()
        return
      }

      Vue.httpClient
        .get('/api/appmgmt/menu/navigation', {params: {urlPath: params.path}})
        .then(response => {
          if (response.data.result) {
            commit('setNavigation', {
              navigation: response.data.result
            })
            for (var i in state.menuList) {
              if (state.menuList[i].menuId == state.navigation[0].menuId) {
                state.middleMenuList = state.menuList[i].menuList
                state.rootMenuName = state.menuList[i].menuNm
                state.lowMenuName = state.navigation[state.navigation.length - 1].menuNm
              }
            }
          }

          resolve()
        })
        .catch(e => reject(e))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/modules/TopMenu.js